import { I18n } from "../@types";
import de from "./de";

export const translate = (): I18n => {
  return de;
};
